import React from "react";
import { LogoIcon, LogoAltIcon } from "../../../icons/LogoIcon";

export default function Logo({
  disableText,
  isAlternate = false,
  branding = {},
}) {
  if (branding && branding.title === "Playfly Sports")
    return (
      <span>
        <img
          src="/assets/playfly/25px_height.png"
          alt=""
          style={{ height: "40px" }}
        />
      </span>
    );
  return (
    <span className={`logo ${isAlternate ? "alternate" : "default"}`}>
      <span className="icon">{isAlternate ? LogoAltIcon : LogoIcon}</span>{" "}
      {!disableText && (
        <>
          <span>Vision Insights</span>
        </>
      )}
    </span>
  );
}
